import { render, staticRenderFns } from "./eventType.vue?vue&type=template&id=40ff8fe7&scoped=true&"
import script from "./eventType.vue?vue&type=script&lang=js&"
export * from "./eventType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff8fe7",
  null
  
)

export default component.exports